export const downloadFile = ({ data, type, mime, filename }) => {
  let blob;
  if (type === 'excel') {
    let binaryString = atob(data);
    const arrayBuffer = stringToArrayBuffer(binaryString)
    blob = new Blob([arrayBuffer], { type: mime });
  } else if (type === 'pdf') {
    const arrayBuffer = stringToArrayBuffer(atob(data))
    blob = new Blob([arrayBuffer], { type: 'application/pdf' });
  } else if (type === 'csv') {
    blob = new Blob([data]);
  }
  let link = document.createElement('a');
  link.href = window.URL.createObjectURL(blob);
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

function stringToArrayBuffer(binaryString) {
  const binaryLength = binaryString.length;
  var buf = new ArrayBuffer(binaryLength);
  var view = new Uint8Array(buf);
  for (let i = 0; i !== binaryLength; ++i) {
    view[i] = binaryString.charCodeAt(i) & 0xFF;
  }
  return buf;
}